(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionDetailController', SuggestionDetailController);

    SuggestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Suggestion'];

    function SuggestionDetailController($scope, $rootScope, $stateParams, previousState, entity, Suggestion) {
        var vm = this;

        vm.suggestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('womenCellApp:suggestionUpdate', function(event, result) {
            vm.suggestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
